// extracted by mini-css-extract-plugin
module.exports = {"centerDisplay":"PolicyFormsComponent_centerDisplay__2QqWC"};